var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#fff",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2380 4794 c-197 -23 -303 -43 -450 -86 -723 -208 -1310 -795 -1518 -1518 -67 -232 -86 -372 -86 -630 0 -258 19 -398 86 -630 216 -751 836 -1349 1595 -1539 214 -54 316 -66 558 -65 238 0 365 16 569 69 616 160 1157 605 1436 1180 104 215 161 392 202 635 29 168 31 510 5 675 -82 506 -307 941 -664 1286 -334 322 -730 521 -1198 600 -115 19 -445 34 -535 23z m370 -324 c581 -61 1098 -374 1416 -861 580 -884 330 -2074 -557 -2656 -219 -143 -465 -238 -749 -290 -133 -24 -467 -24 -600 0 -210 38 -351 83 -529 168 -400 191 -709 501 -901 901 -84 176 -129 318 -167 528 -24 133 -24 467 0 600 39 211 83 352 168 529 184 384 485 693 863 883 223 112 417 168 701 201 65 8 265 6 355 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1535 3666 c-41 -18 -83 -69 -91 -111 -16 -89 -28 -75 449 -552 l442 -443 -442 -442 c-478 -480 -465 -464 -448 -555 9 -49 69 -109 118 -118 91 -17 75 -30 555 448 l442 442 443 -442 c479 -478 463 -465 554 -448 49 9 109 69 118 118 17 91 30 75 -448 555 l-442 442 442 443 c478 479 465 463 448 554 -9 49 -69 109 -118 118 -91 17 -75 30 -555 -448 l-442 -442 -438 437 c-240 240 -450 442 -465 448 -38 14 -85 12 -122 -4z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelar);
export default __webpack_public_path__ + "static/media/cancelar.0d903ba625846659fe5fc245508c05f3.svg";
export { ForwardRef as ReactComponent };